import { type Action, configureStore, type ThunkAction } from '@reduxjs/toolkit';
import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';
import { errorListenerMiddleware } from './middleware/errorListenerMiddleware';
import { rootReducer, RootState } from './rootReducer';

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(errorListenerMiddleware.middleware),
  });
};

export const store = setupStore();

export type AppStore = ReturnType<typeof setupStore>;

// recommended to define these pieces in the redux toolkit docs:
//  https://redux-toolkit.js.org/tutorials/typescript#define-root-state-and-dispatch-types
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export type AppThunk = ThunkAction<void, RootState, undefined, Action<string>>;

if (module.hot) {
  module.hot.accept('./rootReducer', () => {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const newRootReducer = require('./rootReducer').default;
    store.replaceReducer(newRootReducer);
  });
}
